/******************************************************************************************
 *	Selected Customer
 *******************************************************************************************
 *
 * Holds information about the selected customer before transitioning from Customers List to Customer Details.
 *
 */
(function() {
  

  angular.module('rcServices.selectedCustomer', []).service('SelectedCustomer', function() {
    var customer;
    this.set = function(data) {
      customer = data;
    };
    this.get = function() {
      return customer;
    };
    this.clear = function() {
      customer = null;
    };
  });
})();
